<div class="container">
    <div class="me-landing-expert">
        <div tabindex="0" class="me-landing-expert__header">
           {{ data.header}}
        </div>
        <div class="me-landing-expert__body">
            <owl-carousel-o [options]="customOptions">
                <ng-container *ngFor="let item of items">
                    <ng-template carouselSlide>
                        <div tabindex="0" class="carousel-container" (mousedown)="onMouseDown($event)" (click)="openTherapistModal($event, item)">
                            <div class="carousel-container__header">
                                <img class="carousel-img" [src]="item.image">
                            </div>
                            <div class="carousel-container__body">
                                <div class="carousel-container__body--name">
                                    {{item.name}}
                                </div>
                                <div class="carousel-container__body--title">
                                    {{item.title}}
                                </div>
                                <div class="carousel-container__body--languages">
                                    <span *ngFor="let language of item.languages">{{language}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    </ng-container>
            </owl-carousel-o>
        </div>
    </div>
</div>

<div bsModal #modalViewTherapist="bs-modal" class="modal fade modal-show-therapist" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md">
        <button type="button" class="btn-link far fa-times-circle close close-btn" (click)="modalViewTherapist.hide()" aria-label="Close"></button>
        <div class="modal-content">
            <div class="modal-body">
                <div class="active-therapist__header">
                    <div class="">
                        <img class="active-therapist__header--image" [src]="activeTherapist.image">
                    </div>
                    <div class="active-therapist__header__content">
                        <div class="active-therapist__header__content--name">
                            {{activeTherapist.name}}
                        </div>
                        <div class="active-therapist__header__content--divider"></div>
                        <div class="active-therapist__header__content--title">
                            {{activeTherapist.title}}
                        </div>
                        <div class="active-therapist__header__content--joinDate">
                            {{activeTherapist.joinDate}}
                        </div>
                    </div>
                </div>
                <div class="active-therapist__body">
                   <div [innerHTML]="activeTherapist.content | storyblokRichtext"></div>
                </div>
            </div>
        </div>
    </div>
</div>